/* eslint-disable */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import EventListFilterPopup from "../Popup/EventListFilterPopup";

import { getUpComingDates } from "helper/EventHelper/EventHelper";

import { eventslug } from "Config/Config";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData } from "utils/Gateway";
import { assetImages } from "constants";

const EventListBody = () => {
  const eventId = localStorage.getItem("eventId");

  const dateOfToday = new Date().toISOString().split("T")[0];

  const [startDate, setstartDate] = useState("");
  const [endDate, setendDate] = useState("");
  const [startTime, setstartTime] = useState("");
  const [endTime, setendTime] = useState("");

  const [dateTabArr, setDateTabArr] = useState([]);

  const [filterDate, setFilterDate] = useState("");

  const [activeDate, setActiveDate] = useState(null); // State to track active date

  const [isLoading, setIsLoading] = useState(false);
  const [eventList, setEventList] = useState([]);

  //function for get event details
  const getEventDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GUEST_EVENT_DETAILS_BY_ID + `/${eventId}`;

      console.log("url of event details------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response of event details------>", response);

      if (response.status) {
        //assign start date
        setstartDate(response?.data?.fromdate);

        //assign start time
        setstartTime(response?.data?.starttime);

        //assign end date
        setendDate(response?.data?.todate);

        //assign end time
        setendTime(response?.data?.endtime);

        const todayDate = new Date(dateOfToday);
        const fromDateObj = new Date(response.data.fromdate);
        const endDateObj = new Date(response.data.todate);

        if (todayDate >= fromDateObj && todayDate <= endDateObj) {
          getDateOfTabs(dateOfToday);
        } else {
          getDateOfTabs(response.data.fromdate);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //get date list for tabs
  const getDateOfTabs = (dateValue) => {
    const dateArr = getUpComingDates(dateValue);
    setActiveDate(dateArr[0]);
    setDateTabArr(dateArr);
    if (eventId) {
      getAllEvents(dateValue);
    }
  };

  //select date
  const dateSelectionHandler = (dateData) => {
    setActiveDate(dateData); // Set the clicked date as active
    getAllEvents(dateData.fulldate);
  };

  //function for get all lead records
  const getAllEvents = async (eventDate) => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GUEST_EVENT_LIST +
        `?filterparentid=${eventId}&filterdates=${eventDate}`;

      console.log("url of event list---------->", requestUrl);

      const response = await getData(requestUrl);

      console.log("response in event list------->", response);

      setIsLoading(false);
      if (response.status) {
        setEventList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //reset filter
  const refreshHandler = () => {
    getEventDetails();
  };

  useEffect(() => {
    if (filterDate != "") {
      getDateOfTabs(filterDate);
      getAllEvents(filterDate);
      setFilterDate("");
    }
  }, [filterDate]);

  useEffect(() => {
    getEventDetails();
  }, []);

  return (
    <section className="inner_sec">
      <div className="container">
        <div className="page_heading mb-5 d-flex align-items-center justify-content-between">
          <h1 className="position-relative pb-4 text-uppercase">Events</h1>

          <div className="d-flex align-items-center">
            <Link
              to="#"
              className="filter_btn d-flex align-items-center justify-content-center bg_primary me-2"
              onClick={refreshHandler}
            >
              <span className="material-icons-outlined text-white">
                refresh
              </span>
            </Link>
            <Link
              to="#"
              className="filter_btn d-flex align-items-center justify-content-center bg_primary"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight"
            >
              <span className="material-icons-outlined text-white">
                filter_list
              </span>
            </Link>
          </div>
        </div>

        {/* date tabs */}
        <div className="tab_links">
          <ul className="nav nav-tabs">
            {dateTabArr.map((dateData, index) => {
              return (
                <li className="nav-item" key={index}>
                  <Link
                    to="#"
                    className={`nav-link ${
                      activeDate === dateData ? "active" : ""
                    }`}
                    onClick={() => {
                      dateSelectionHandler(dateData);
                    }}
                  >
                    <span className="d-block text-primary text-uppercase fw-semibold fs-md text-center mb-1">
                      {dateData.day}
                    </span>
                    <span className="d-block text-primary-gray text-center fs-sm text-center">
                      {dateData.month} {dateData.year}
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>

        {isLoading ? (
          <div className="meet_row bg_white p-4 d-flex mb-3">
            <div className="meet_time_left">
              <h3
                className="d-flex align-items-center gap-2 mb-2 placeholder placeholder-sm"
                style={{ width: "50%" }}
              ></h3>
              <h5
                className="d-flex align-items-center gap-2 placeholder placeholder-sm"
                style={{ width: "35%" }}
              ></h5>
            </div>
            <div className="meet_time_right">
              <h3 className="text-uppercase fs-xl text-primary mb-3">
                <i
                  className="placeholder placeholder-sm"
                  style={{ width: "15%" }}
                ></i>
              </h3>
              <h3 className="text-uppercase fs-xl text-primary mb-3">
                <span
                  className="d-inline-block fs-sm fw-medium placeholder placeholder-sm"
                  style={{ width: "35%", height: "25px" }}
                ></span>
              </h3>

              <p>
                <span className="d-block fs-sm text-primary-gray fw-medium placeholder placeholder-sm mb-3"></span>
                <span className="d-block fs-sm text-primary-gray fw-medium placeholder placeholder-sm mb-3"></span>
                <span className="d-block fs-sm text-primary-gray fw-medium placeholder placeholder-sm mb-3"></span>
                <span className="d-block fs-sm text-primary-gray fw-medium placeholder placeholder-sm mb-3"></span>
                <span className="d-block fs-sm text-primary-gray fw-medium placeholder placeholder-sm mb-3"></span>
                <span className="d-block fs-sm text-primary-gray fw-medium placeholder placeholder-sm mb-3"></span>
              </p>
              <div className="meet_btns d-flex align-items-center gap-2 mt-3">
                {/* <Link to="#" className="btn primary-btn">
                Accept
              </Link> */}
                <span
                  className="btn primary-btn placeholder"
                  style={{ width: "140px", height: "50px" }}
                ></span>
              </div>
            </div>
          </div>
        ) : eventList.length > 0 ? (
          <div className="meet_bx_outer">
            {eventList.map((eventDataItem, index) => {
              return (
                <div className="meet_row bg_white p-4 d-flex mb-3" key={index}>
                  <div className="meet_time_left">
                    <h3 className="d-flex align-items-center gap-2 mb-2">
                      <i className="material-icons-outlined text-pink fs-md">
                        schedule
                      </i>
                      <span className="fs-lg fw-bold text-primary">
                        {eventDataItem.starttime} - {eventDataItem.endtime}
                      </span>
                    </h3>
                    <h5 className="d-flex align-items-center gap-2">
                      <i className="material-icons-outlined fs-md text-primary-gray">
                        event_note
                      </i>
                      <span className="text-primary-gray fs-sm">
                        {eventDataItem.fromdate}
                      </span>
                    </h5>
                  </div>
                  <div className="meet_time_right">
                    <div className="d-flex align-items-center gap-1 mb-2">
                      <i className="material-icons-outlined text-primary-gray fs-sm">
                        my_location
                      </i>
                      <span className="d-inline-block fs-sm text-primary-gray">
                        {eventDataItem.address}
                      </span>
                    </div>
                    <h3 className="text-uppercase fs-xl text-primary d-flex align-items-center gap-2 mb-3">
                      {eventDataItem.title}
                    </h3>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: eventDataItem.description,
                      }}
                    ></p>
                    <div className="meet_btns d-flex align-items-center gap-2 mt-3">
                      <Link
                        to={`/event/details/${eventDataItem._id}`}
                        className="btn primary-btn"
                      >
                        View Details
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="no_events text-center">
            <span className="d-block text-center mb-2">
              <img src={assetImages.handsCalendar} alt="" />
            </span>
            <h5 className="text-primary fs-sm ">No event to show</h5>
          </div>
        )}
      </div>
      <EventListFilterPopup setFilterDate={setFilterDate} />
    </section>
  );
};

export default EventListBody;
